import axios from 'axios'

import log from 'salvo-lite/log'

class Variant {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._data = Object.assign({
            product: elem.closest('[data-product]'),
            selectors: {
                selectedVariantField: '[data-product-selected-variant]',
                variant: '[data-variant]',
                images: 'product__images'
            },
            ajaxElementSelectors: [
                '.product__ignore',
                '.product__price',
                '.product__images',
                '.product__variants',
                '.product__tags',
                '.product__actions',
                '.nutritional-info',
                '.product-add-bar .container',
                '.product__description',
                '.product--mobile .product-accordion',
                '.product-accordion.hidden-tablet',
                '.product__title'
            ],
            ajaxElementSelectorsSizeOnly: [
                '.product__ignore',
                '.product__price',
                '.product__variants',
                '.product__actions',
                '.nutritional-info',
                '.product-add-bar .container',
                '.product__description'
            ]
        }, JSON.parse(elem.getAttribute('data-variants') || '{}'))
        this._data.selectedVariantField = this._data.product.querySelector(this._data.selectors.selectedVariantField)
        this._data.variants = this._data.product.querySelectorAll(this._data.selectors.variant)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const {variants} = this._data
        variants.forEach(variant => {
            variant.addEventListener('change', () => {
                if (variant.checked) {
                    if (document.body.classList.contains('template-full-bundle')) {
                        this._updateBundleItem(variant)
                    } else {
                        this._isSize = variant.getAttribute('data-variant') === 'size'
                        this._updateURL(variant.value)
                        this._updateSelectedVariantField(variant.value)
                        this._updateContent(variant)
                    }
                }
            })
        })
    }

    _updateBundleItem (variant) {
        let bundleItem = variant.closest('.product-variants__option-values').querySelector('[data-bundle-selected-product]')
        bundleItem.value = variant.value
    }

    _updateURL (newVariantID) {
        const newUrl = `${window.location.origin}${window.location.pathname}?variant=${newVariantID}`
        window.history.pushState({path: newUrl}, '', newUrl)
    }

    _updateSelectedVariantField (newVariantID) {
        const {selectedVariantField} = this._data
        selectedVariantField.value = newVariantID
    }

    _getAjaxElements (productElement = this._data.product) {
        if (this._isSize) {
            return this._data.ajaxElementSelectorsSizeOnly.map(selector => productElement.querySelectorAll(selector))
        } else {
            return this._data.ajaxElementSelectors.map(selector => productElement.querySelectorAll(selector))
        }
    }

    _updateContent (newVariant) {
        const newVariantID = newVariant.value
        const {productHandle} = this._data
        const ajaxURL = `/products/${productHandle}?variant=${newVariantID}`
        const existingAjaxElements = this._getAjaxElements()

        this._blurImages()

        axios.get(ajaxURL).then((response) => {
            const productPageContent = document.createElement('div')
            productPageContent.innerHTML = response.data

            const newAjaxElements = this._getAjaxElements(productPageContent.querySelector('[data-product]'))

            existingAjaxElements.forEach((elementList, elementListIndex) => elementList.forEach((element, elementIndex) => {
                this._replaceElement(element, newAjaxElements[elementListIndex][elementIndex])
            }))
        }).then(() => {
            setTimeout(() => this._blurImages(false), 100)
        }).catch(error => console.error(error))
    }

    _blurImages (blur = true) {
        if (!this._isSize) {
            blur ? this._data.product.classList.add('blur-images') : this._data.product.classList.remove('blur-images')
        }
    }

    _replaceElement (oldElement, newElement) {
        if (oldElement.parentNode !== null) {
            this._removePreloader(oldElement, newElement)
            oldElement.parentNode.replaceChild(newElement, oldElement)
            this._wrapAndReRegisterComponent(newElement)
        }
    }

    _removePreloader (oldElement, newElement) {
        if (oldElement.classList.contains(this._data.selectors.images)) {
            newElement.querySelectorAll('img').forEach(img => {
                if (img.hasAttribute('data-preload')) {
                    img.src = img.getAttribute('data-preload')
                    img.removeAttribute('data-preload')
                }
            })
        }
    }

    _wrapAndReRegisterComponent (newElement) {
        const temporaryWrapper = document.createElement('div')
        newElement.parentNode.insertBefore(temporaryWrapper, newElement)
        temporaryWrapper.appendChild(newElement)
        this._theme.registerComponents(temporaryWrapper)
        temporaryWrapper.parentNode.insertBefore(newElement, temporaryWrapper)
        temporaryWrapper.parentNode.removeChild(temporaryWrapper)
    }
}

export default Variant



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variants.js